import { useState } from "react";
import { Modal, ModalBody } from "reactstrap";



const RefundModal = ({data, onRefund}) => {

    const [isOpen, setIsOpen] = useState(false);

    /**
    * on toggle modal
    */
    const toggle = () => {
        setIsOpen(prevOpenStatus => !prevOpenStatus);
    };

    return (
        <>
            <button type="button" class="btn btn-sm btn-outline-danger px-4 py-2" onClick={() => toggle()}>
              Refund
            </button>
            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalBody>
                <div className="">
                    <div className="rd_modalvieew">
                    <div className="box_content rd_modalboxcontent">
                        <div className="rd_inputselectheadermodalsetting">
                        <button
                            className="rd_colsebtn"
                            onClick={toggle}
                        ></button>
                        </div>

                        <h5 className="rd_modalheadertext rd_modalheadertextnm">
                        Confirm
                        </h5>

                        <p className="rd_modalheadertextparath mt-5 mb-5">
                        Are you sure, you want to Refund ?
                        </p>

                        <div className="rd_cancelappbtnmodal">
                        <button className="rd_cancel" onClick={toggle}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-app"
                            onClick={() => {
                                toggle();
                                onRefund(data.id);
                            }}
                        >
                            Confirm
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default RefundModal;



